'use strict';
module.exports = function validAccountName(accountName) {
	return !!(accountName && accountName.length > 3 && /^[a-z][a-z0-9]{3,20}$/.test(accountName));
};
